<script>
  export let text;
  import { Block } from '@reuters-graphics/graphics-components';
  import { Markdown } from '@reuters-graphics/svelte-markdown';
</script>

<Block class="normal ">
  <div class="prologue-text fmt-9"><Markdown source={text} /></div>
</Block>

<style lang="scss">
  @use '@reuters-graphics/graphics-components/dist/scss/mixins' as mixins;
  :global(.prologue-text p) {
    font-family: 'LibreBodoni-Regular';
  }

  @media (max-width: 674px) {
    .prologue-text {
      @include mixins.fmt-9;
    }
  }
</style>
